export default function MultiplyIcon() {
    return (
        <svg width="10" height="10" viewBox="0 0 10 10">
            <path d="M1 9L9 1" stroke="black" />
            <path d="M1 1L9 9" stroke="black" />
        </svg>
    );
}
